import { cwslapi } from "../index";

// 获取专题活动信息
export const getActivityInfoApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/getActivityInfo",
    method: "post",
    data,
  });
};


// 金龙元宝兑换双旦好运币
export const exchangeApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/exchange",
    method: "post",
    data,
  });
};

// 活动抽奖
export const doLotteryApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/doLottery",
    method: "post",
    data,
  });
};

// 购买隐藏商店商品
export const buyHiddenShopItemApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/buyHiddenShopItem",
    method: "post",
    data,
  });
};

// 获取抽奖记录
export const getActivityLogApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/getActivityLog",
    method: "post",
    data,
  });
};


// 领取累计抽奖里程碑奖励
export const claimMilestoneRewardApi = (data) => {
  return cwslapi({
    url: "/lotteryActivity/claimMilestoneReward",
    method: "post",
    data,
  });
};